import { createSlice } from '@reduxjs/toolkit'

import { DefectComment, fetchDefectCommentsByDefectIdAction } from '../actions/defectComments'
import { createDefectCommentAction } from '../actions/defectComments/actions'
import { ActionStatus } from '../types/Input'

export interface DefectCommentsState {
  commentsByDefectId: Record<string, DefectComment[]>
  fetchStatusByDefectId: Record<string, ActionStatus>
  fetchErrorByDefectId: Record<string, string | undefined>
  createStatusByDefectId: Record<string, ActionStatus>
  createErrorByDefectId: Record<string, string | undefined>
}

const initialState: DefectCommentsState = {
  commentsByDefectId: {},
  fetchStatusByDefectId: {},
  fetchErrorByDefectId: {},
  createStatusByDefectId: {},
  createErrorByDefectId: {},
}

export const defectCommentsSlice = createSlice({
  name: 'defectComments',
  initialState,
  reducers: {
    clearCreateStatusByDefectId: (state, { payload }: { payload: string }) => {
      state.createStatusByDefectId[payload] = 'none'
      state.createErrorByDefectId[payload] = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDefectCommentsByDefectIdAction.pending, (state, { meta }) => {
      state.fetchStatusByDefectId[meta.arg] = 'loading'
      state.fetchErrorByDefectId[meta.arg] = undefined
    })

    builder.addCase(fetchDefectCommentsByDefectIdAction.fulfilled, (state, { payload, meta }) => {
      state.commentsByDefectId[meta.arg] = payload
      state.fetchStatusByDefectId[meta.arg] = 'succeeded'
    })

    builder.addCase(fetchDefectCommentsByDefectIdAction.rejected, (state, { payload, meta }) => {
      state.fetchStatusByDefectId[meta.arg] = 'failed'
      if (payload) {
        state.fetchErrorByDefectId[meta.arg] = payload.message
      }
    })

    builder.addCase(createDefectCommentAction.pending, (state, { meta }) => {
      state.createStatusByDefectId[meta.arg.defectId] = 'loading'
      state.createErrorByDefectId[meta.arg.defectId] = undefined
    })

    builder.addCase(createDefectCommentAction.fulfilled, (state, { payload, meta }) => {
      const defectId = meta.arg.defectId
      const createdComment: DefectComment = {
        comment: payload.comment,
        created: payload.created,
        ownComment: true,
        crewType: payload.crewType,
      }

      if (!state.commentsByDefectId[defectId]) {
        state.commentsByDefectId[defectId] = []
      }
      state.commentsByDefectId[defectId].push(createdComment)
      state.createStatusByDefectId[defectId] = 'succeeded'
    })

    builder.addCase(createDefectCommentAction.rejected, (state, { payload, meta }) => {
      const defectId = meta.arg.defectId
      state.createStatusByDefectId[defectId] = 'failed'
      if (payload) {
        state.createErrorByDefectId[defectId] = payload.message
      }
    })
  },
})

export const { clearCreateStatusByDefectId } = defectCommentsSlice.actions

export default defectCommentsSlice.reducer
